import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from '../../core/services/cookie-consent.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { ToggleComponent } from '../toggle/toggle';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [RouterLink, TranslatePipe, ToggleComponent],
  templateUrl: './cookie-consent.html',
})
export class CookieConsentComponent {
  protected readonly consentService = inject(CookieConsentService);

  protected readonly customizing = signal(false);
  protected readonly analyticsDraft = signal(false);
  protected readonly adsDraft = signal(false);

  protected acceptAll(): void {
    this.consentService.acceptAll();
    this.customizing.set(false);
  }

  protected rejectNonEssential(): void {
    this.consentService.rejectNonEssential();
    this.customizing.set(false);
  }

  protected startCustomize(): void {
    const current = this.consentService.consent();
    this.analyticsDraft.set(current.analytics);
    this.adsDraft.set(current.ads);
    this.customizing.set(true);
  }

  protected saveCustom(): void {
    this.consentService.savePreferences(this.analyticsDraft(), this.adsDraft());
    this.customizing.set(false);
  }
}
